import React, { Component } from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSignOutAlt,
    faTachometerAlt,
    faUsers,
    faTasks,
    faFolderOpen,
    faCamera
} from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import { logoutUser } from "../../actions/authActions";
import { Link } from "react-router-dom";

class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isExpanded: document.body.classList.contains("sidebar-expanded")
        };
    }

    toggleSidebar = () => {
        document.body.classList.toggle("sidebar-expanded");
        this.setState({
            isExpanded: document.body.classList.contains("sidebar-expanded")
        });
    };

    onLogoutClick = (e) => {
        e.preventDefault();
        this.props.logoutUser();
    };

    render() {
        const { user } = this.props.auth;
        return (
            <div className="border-end h-100 bg-light position-relative" id="sidebar-wrapper">
                <div className="list-group list-group-flush">
                    <Link to="/dashboard" className="list-group-item list-group-item-action d-flex align-items-center">
                        <FontAwesomeIcon icon={faTachometerAlt} />
                        <span className="sidebar-label">Dashboard</span>
                    </Link>
                    {user.role === 1 && (
                        <Link to="/users" className="list-group-item list-group-item-action d-flex align-items-center">
                            <FontAwesomeIcon icon={faUsers} />
                            <span className="sidebar-label">Users</span>
                        </Link>
                    )}
                    <Link to="/tasks" className="list-group-item list-group-item-action d-flex align-items-center">
                        <FontAwesomeIcon icon={faTasks} />
                        <span className="sidebar-label">Tasks</span>
                    </Link>
                            <Link to="/snapshot" className="list-group-item list-group-item-action d-flex align-items-center">
                                <FontAwesomeIcon icon={faCamera} />
                                <span className="sidebar-label">Snapshot</span>
                            </Link>
                        {user.role === 1 && (
                            <Link to="/projects" className="list-group-item list-group-item-action d-flex align-items-center">
                                <FontAwesomeIcon icon={faFolderOpen} />
                                <span className="sidebar-label">Projects</span>
                            </Link>
                    )}
                    <button
                        className="list-group-item list-group-item-action d-flex align-items-center"
                        onClick={this.onLogoutClick}
                    >
                        <FontAwesomeIcon icon={faSignOutAlt} />
                        <span className="sidebar-label">Logout</span>
                    </button>
                </div>
            </div>
        );
    }
}

Sidebar.propTypes = {
    logoutUser: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
    auth: state.auth
});

export default connect(mapStateToProps, { logoutUser })(Sidebar);
